"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IconIncomeFilled = function IconIncomeFilled(_ref) {
  var className = _ref.className,
      color = _ref.color,
      size = _ref.size;
  return _react.default.createElement("svg", {
    id: "icons",
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 50 50"
  }, _react.default.createElement("title", null, "income"), _react.default.createElement("path", {
    d: "M35.89,20H14.11A6.75,6.75,0,0,1,10,24.2v4.61A6.75,6.75,0,0,1,14.11,33H35.89A6.75,6.75,0,0,1,40,28.8V24.2A6.75,6.75,0,0,1,35.89,20ZM25,30a4,4,0,1,1,4-4A4,4,0,0,1,25,30Z",
    fill: color
  }), _react.default.createElement("path", {
    d: "M4.88,15V38H45.12V15ZM42,30.36A4.78,4.78,0,0,0,37.47,35H12.53A4.78,4.78,0,0,0,8,30.36V22.64A4.78,4.78,0,0,0,12.53,18H37.47A4.78,4.78,0,0,0,42,22.64Z",
    fill: color
  }));
};

IconIncomeFilled.defaultProps = {
  color: 'black',
  size: 30
};
IconIncomeFilled.propTypes = {
  color: _propTypes.string,
  className: _propTypes.string
};
var _default = IconIncomeFilled;
exports.default = _default;